<template>
  <div class="profitability" ref="slideContainer">
    <Title :zhTitle="pageData.name" :enTitle="pageData.name"></Title>
    <div class="top">
      <div>
        <span v-if="language === 'zh'" class="zh_income">基本每股收益 </span>
        <span v-else-if="language === 'en'" class="en_income">Basic EPS </span>
        <span class="money">
					{{ jbmgsy }}<span class="unit" v-if="language === 'zh'">{{ jbmgsyUnit }}</span></span
        >
      </div>
    </div>
    <div class="cards">
      <div class="card" v-if="mll">
        <div v-if="language === 'zh'" class="zh">
          <div class="card-title">{{ jsonData.year }}{{ periodName }} <span class="card-text">毛利率</span></div>
          <div class="num">
            {{ mll }}<span class="unit">{{ mllUnit }}</span>
          </div>
        </div>
        <div v-else-if="language === 'en'" class="en">
          <div class="card-title">{{ jsonData.year }}{{ periodNameEng }} <span class="card-text">Gross Margin</span>
          </div>
          <div class="num">
            {{ mll }}<span class="unit">{{ mllUnit }}</span>
          </div>
        </div>
        <div class="charts" ref="chart1"></div>
      </div>
      <div class="card" v-if="jzcsyl">
        <div v-if="language === 'zh'" class="zh">
          <div class="card-title">{{ jsonData.year }}{{ periodName }} <span class="card-text">净资产收益率</span></div>
          <div class="num">
            {{ jzcsyl }}<span class="unit">{{ jzcsylUnit }}</span>
          </div>
        </div>
        <div v-else-if="language === 'en'" class="en">
          <div class="card-title">{{ jsonData.year }}{{ periodNameEng }} <span class="card-text">ROE</span></div>
          <div class="num">
            {{ jzcsyl }}<span class="unit">{{ jzcsylUnit }}</span>
          </div>
        </div>
        <div class="charts" ref="chart2"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/title.vue'
import {mapState} from 'vuex'
import * as echarts from 'echarts'

export default {
  name: 'profitability1',
  components: {
    Title,
  },
  props: {
    index: {
      type: Number,
    },
  },
  data() {
    return {
      observer: null, // IntersectionObserver 对象
      barOption: {
        xAxis: [
          {
            type: 'value',
            max: 100,
            show: false,
          },
        ],
        yAxis: [
          {
            type: 'category',
            axisLine: {
              show: false,
              lineStyle: {
                color: '#F0F0F0',
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: '#696969',
            },
            data: [],
          },
        ],
        grid: {
          top: 20,
          left: '8%',
          right: '8%',
          bottom: -20,
          containLabel: true,
        },
        series: [
          {
            type: 'pictorialBar', //pictorialBar(象形柱图)
            symbolSize: [6, 11], //椭圆的大小[宽，高]
            symbolOffset: [1, 0], //图形偏移[x轴，y轴]，不确定的话，可以微调，本实例x轴叠加了柱状之间的间距[-7+(间距7/2),y轴]
            z: 12, //图形的层级，控制图形的前后顺序，z值小的图形会被z值大的图形覆盖
            symbolPosition: 'end', //椭圆位置，默认'start'，在最底下，end是最上面
            itemStyle: {
              color: '#F06160',
            },
            data: [],
          },
          {
            type: 'bar',
            barWidth: 11,
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(211, 47, 46, 0.12)',
              borderRadius: 6,
            },
            label: {
              show: true,
              position: 'right',
              offset: [-53, -15],
              color: '#F78A16',
              fontSize: 14,
              fontWeight: 600,
              formatter: '{c}%',
            },
            itemStyle: {
              borderRadius: 6,
              // 图形样式
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#FEAB66',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#d32f2e',
                },
              ]),
            },
            data: [],
          },
          // 第一个圆柱底部的椭圆形
          {
            type: 'pictorialBar',
            symbolSize: [6, 11],
            symbolOffset: [-1, 0],
            z: 12,
            itemStyle: {
              color: '#F06160',
            },
            data: [],
          },
        ],
      },
      bar1Data: {
        yAxisData: [],
        seriesData: [],
      },
      bar2Data: {
        yAxisData: [],
        seriesData: [],
      },
      pageData: {},
      jbmgsy: '',
      jbmgsyUnit: '',
      mll: '',
      mllUnit: '',
      jzcsyl: '',
      jzcsylUnit: '',
    }
  },
  computed: {
    ...mapState(['theme', 'language', 'jsonData', 'periodName', 'periodNameEng', 'isLongChart']),
  },
  watch: {
    language(newVal, oldVal) {
      this.initData() // 语言切换重新初始化数据
    }
  },
  mounted() {
    this.initData(); // 初始化数据
  },
  beforeDestroy() { // 组件销毁时，销毁echarts实例
    const myChart1 = echarts.init(this.$refs.chart1)
    const myChart2 = echarts.init(this.$refs.chart2)
    if (this.observer) {
      this.observer.disconnect()
    }
    if (myChart1) {
      myChart1.dispose()
    }
    if (myChart2) {
      myChart2.dispose()
    }
  },
  methods: {
    initData() { // 初始化数据
      this.initObserver() // 初始化IntersectionObserver

      let data = JSON.parse(this.jsonData.moduleData)
      if (this.language == 'zh') { // 根据语言获取相应数据
        data = JSON.parse(this.jsonData.moduleData)
      } else {
        data = JSON.parse(this.jsonData.moduleDataEng)
      }
      this.pageData = data[this.index] // 获取当前页面数据
      this.type = data[this.index].graphId == 5 ? '3d' : data[this.index].graphId == 1 ? 'bar' : 'area' // 获取图形类型

      if (this.pageData.jbmgsyData.length > 0) { // 获取基本每股收益数据
        this.jbmgsy = this.pageData.jbmgsyData[0].value
        this.jbmgsyUnit = this.pageData.jbmgsyData[0].unit
      } else {
        this.jbmgsy = this.language === 'zh' ? '未披露' : 'Undisclosed';
      }

      if (this.pageData.mllData.length > 0) { // 获取毛利率数据
        if (this.pageData.mllData[0].period.match(/\d+/) != this.jsonData.year) { // 判断是否为最新年份数据并且有数据
          this.mll = this.language === 'zh' ? '未披露' : 'Undisclosed';
        } else {
          this.mll = (this.pageData.mllData[0].realityValue)
          this.mllUnit = this.pageData.mllData[0].unit
        }
        this.bar1Data.yAxisData = []; // 清空数组
        this.bar1Data.seriesData = []; // 清空数组
        this.pageData.mllData.forEach(item => {
          this.bar1Data.yAxisData.push(item.period) // 获取y轴数据
          this.bar1Data.seriesData.push({value: (item.value), label: (item.realityValue)}) // 获取x轴数据
        })
      }
      if (this.pageData.jzcsylData.length > 0) { // 获取净资产收益率数据
        if (this.pageData.jzcsylData[0].period.match(/\d+/) != this.jsonData.year) { // 判断是否为最新年份数据并且有数据
          this.jzcsyl = this.language === 'zh' ? '未披露' : 'Undisclosed';
        } else {
          this.jzcsyl = (this.pageData.jzcsylData[0].realityValue)
          this.jzcsylUnit = this.pageData.jzcsylData[0].unit
        }
        this.bar2Data.yAxisData = []; // 清空数组
        this.bar2Data.seriesData = []; // 清空数组
        this.pageData.jzcsylData.forEach(item => {
          this.bar2Data.yAxisData.push(item.period) // 获取y轴数据
          this.bar2Data.seriesData.push({value: (item.value), label: (item.realityValue)}) // 获取x轴数据
        })
      }
    },
    initObserver() { // 初始化IntersectionObserver
      if (this.isLongChart) { // 如果是长图，则直接初始化echarts
        setTimeout(() => {
          this.initChart();
        }, 200)
      } else {
        // 创建一个新的 IntersectionObserver 对象，当其监听到目标元素的可见部分（的比例）超过了一个或多个阈值（threshold）时，会执行指定的回调函数
        this.observer = new IntersectionObserver(
            entries => {
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  this.initChart() // 初始化echarts
                  this.observer.disconnect() // 一旦元素进入视窗，就断开观察器
                }
              })
            },
            {
              threshold: 0.1, // 当目标元素的可见比例达到0%时，触发回调
            }
        )
        this.observer.observe(this.$refs.slideContainer)
      }

    },
    initChart() {
      if (this.$refs.chart1) { // 初始化图表
        const myChart1 = echarts.init(this.$refs.chart1) // 获取图表实例
        const option1 = JSON.parse(JSON.stringify(this.barOption))
        option1.yAxis[0].data = this.bar1Data.yAxisData // 设置y轴数据
        option1.series[0].data = this.bar1Data.seriesData // 设置x轴数据
        if (this.type == '3d') { // 3d图形
          let topArr = []
          topArr = this.bar1Data.seriesData.map(item => { // 设置顶部圆柱的数组
            if (item.label < 0) {
              return {
                value: item.value,
                symbolOffset: [0, 0],
              }
            } else {
              return {
                value: item.value,
              }
            }
          })
          let bottomArr = []
          bottomArr = this.bar1Data.seriesData.map(item => { // 获取底部圆柱的数组
            if (item.value < 0) {
              return {
                value: item.value,
                symbolOffset: [0, 0],
              }
            } else {
              return {
                value: item.value,
              }
            }
          })
          option1.series[0].data = topArr // 设置顶部圆柱的数组
          option1.series[1].data = this.bar1Data.seriesData // 设置x轴数据
          option1.series[2].data = bottomArr // 设置底部圆柱的数组
          option1.series[1].backgroundStyle = { // 设置数据的背景颜色
            color: '#fff',
            borderRadius: 0,
          }
          option1.series[1].itemStyle.color = params => { // 设置柱子的颜色
            if (params.data.value < 0) { // 根据数值正负设置颜色渐变
              return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 0, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            } else {
              return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            }
          }
        } else if (this.type == 'bar') { // 柱状图
          option1.series[0].data = [] // 清空顶部数据
          option1.series[1].data = this.bar1Data.seriesData // 设置数据
          option1.series[1].itemStyle.borderRadius = 8 // 设置柱子圆角
          option1.series[2].data = [] // 清空底部数据
        } else if (this.type == 'area') { // 折线图
          option1.series[0].data = [] // 清空顶部数据
          option1.series[1].data = this.bar1Data.seriesData // 设置数据
          option1.series[1].type = 'line' // 设置折线图
          option1.series[1].smooth = true // 设置平滑折线
          option1.series[1].symbol = 'circle' // 设置折线图圆点样式
          option1.series[1].symbolSize = 6 // 设置折线图圆点大小
          option1.series[1].areaStyle = { // 设置折线图区域颜色
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              {
                offset: 1,
                color: 'rgba(254,171,102,0)',
              },
              {
                offset: 0,
                color: 'rgba(235,92,91,0.7)',
              },
            ]),
          }
          option1.series[2].data = [] // 清空底部数据
        }
        if (this.theme == 'red') { // 红色
          if (this.type != "area") { // 3d、柱状图
            option1.series[1].itemStyle.color = params => { // 设置柱子的颜色
              if (params.data.value < 0) { // 根据数值正负设置颜色渐变
                return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0, // 0%处的颜色
                    color: '#d32f2e',
                  },
                  {
                    offset: 1, // 100%处的颜色
                    color: '#FEAB66',
                  },
                ])
              } else {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 0, // 0%处的颜色
                    color: '#d32f2e',
                  },
                  {
                    offset: 1, // 100%处的颜色
                    color: '#FEAB66',
                  },
                ])
              }
            }
          }
        } else if (this.theme == 'purple') { // 紫色
          option1.series[0].itemStyle.color = '#FFF1D0' // 设置顶部柱子颜色
          option1.series[1].itemStyle.color = '#F9CD70' // 设置中间柱子颜色
          if (option1.series[1].areaStyle) { // 如果折线图有数据设置颜色渐变
            option1.series[1].areaStyle = {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: 'rgba(249, 205, 112, 0)',
                },
                {
                  offset: 0,
                  color: 'rgba(249, 205, 112, 0.70)',
                },
              ]),
            }
          }
          if (this.type != '3d') { // 如果是柱状图、折线图设置背景颜色
            option1.series[1].backgroundStyle.color = 'rgba(249,205,112,0.2)'
          }
          option1.series[1].label.color = '#2A234C' // 设置文字颜色
          option1.series[1].label.fontSize = 12 // 设置文字大小
          option1.series[1].label.fontWeight = 400 // 设置文字粗细
          option1.series[2].itemStyle.color = '#EBB94F' // 设置底部柱子颜色
        } else if (this.theme == 'blue') { // 蓝色
          option1.color = ['#4782EA'] // 设置颜色
          if (this.type == '3d') { // 3d
            option1.series[1].backgroundStyle = { // 设置背景颜色
              color: '#ECF2FD',
              borderRadius: 0,
            }
          } else { // 柱状图、折线图
            option1.series[1].backgroundStyle.color = '#E5E5E5'
          }
          option1.series[0].itemStyle.color = '#92D5FF' // 设置顶部柱子颜色
          option1.series[1].itemStyle.color = params => { // 设置柱子的颜色
            if (params.data.value < 0) { // 根据数值正负设置颜色渐变
              return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1, // 0%处的颜色
                  color: '#59B9F5',
                },
                {
                  offset: 0, // 100%处的颜色
                  color: '#D7F0FF',
                },
              ])
            } else {
              return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#59B9F5',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#D7F0FF',
                },
              ])
            }
          }
          if (option1.series[1].areaStyle) { // 如果折线图有数据设置颜色渐变
            option1.series[1].areaStyle = {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: 'rgba(91, 186, 245, 0)',
                },
                {
                  offset: 0,
                  color: 'rgba(103, 191, 245, 1)',
                },
              ]),
            }
          }
          option1.series[1].label.color = '#000000' // 设置文字颜色
          option1.series[1].label.fontSize = 12 // 设置文字大小
          option1.series[1].label.fontWeight = 400 // 设置文字粗细
          option1.series[2].itemStyle.color = '#C0E6FF' // 设置底部柱子颜色
        } else if (this.theme == 'yellow') { // 黄色
          option1.color = ['#F8BC27'] // 设置颜色

          option1.series[0].itemStyle.color = '#FFBE1E' // 设置顶部柱子颜色
          option1.series[1].itemStyle.color = params => { // 设置柱子的颜色
            if (params.data.value < 0) { // 根据数值正负设置颜色渐变
              return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                {
                  offset: 1, // 0%处的颜色
                  color: 'rgba(248,188,39,0)',
                },
                {
                  offset: 0, // 100%处的颜色
                  color: 'rgba(248,188,39,0.7)',
                },
              ])
            } else {
              return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: 'rgba(248,188,39,0)',
                },
                {
                  offset: 0,
                  color: 'rgba(248,188,39,0.7)',
                },
              ])
            }
          }
          if (this.type == 'bar') { // 柱状图
            option1.series[1].itemStyle.color = '#F8BC27' // 设置柱子颜色
            option1.series[1].backgroundStyle.color = '#EAEAEA' // 设置背景颜色
          }
          if (option1.series[1].areaStyle) { // 如果折线图有数据设置颜色渐变
            option1.series[1].areaStyle = {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: 'rgba(248,188,39,0)',
                },
                {
                  offset: 0,
                  color: 'rgba(248,188,39,0.7)',
                },
              ]),
            }
          }
          option1.series[1].label.color = '#000000' // 设置文字颜色
          option1.series[1].label.fontSize = 12 // 设置文字大小
          option1.series[1].label.fontWeight = 400 // 设置文字粗细
          option1.series[2].itemStyle.color = '#DFA20A' // 设置底部柱子颜色
        }
        const arr = this.bar1Data.seriesData.filter(item => item.value < 0) // 获取负数
        if (arr.length > 0) { // 如果有负数设置负数轴
          option1.xAxis[0].min = -100
          option1.yAxis[0].axisLine.show = true
        }
        option1.series[1].label.formatter = function (params) {
          // 使用自定义的 labelValue 来显示标签
          return params.data.label + '%'
        }
        myChart1.setOption(option1)
      }

      if (this.$refs.chart2) {
        const myChart2 = echarts.init(this.$refs.chart2)
        const option2 = JSON.parse(JSON.stringify(this.barOption))
        option2.yAxis[0].data = this.bar2Data.yAxisData
        option2.series[0].data = this.bar2Data.seriesData
        if (this.type == '3d') {
          let topArr = []
          topArr = this.bar2Data.seriesData.map(item => {
            if (item.value < 0) {
              return {
                value: item.value,
                symbolOffset: [0, 0],
              }
            } else {
              return {
                value: item.value,
              }
            }
          })
          let bottomArr = []
          bottomArr = this.bar2Data.seriesData.map(item => {
            if (item.value < 0) {
              return {
                value: item.value,
                symbolOffset: [0, 0],
              }
            } else {
              return {
                value: item.value,
              }
            }
          })
          option2.series[0].data = topArr
          option2.series[1].data = this.bar2Data.seriesData
          option2.series[2].data = bottomArr
          option2.series[1].backgroundStyle = {
            color: '#fff',
            borderRadius: 0,
          }
          option2.series[1].itemStyle.color = params => {
            if (params.data.value < 0) {
              return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 0, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            } else {
              return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            }
          }
        } else if (this.type == 'bar') {
          option2.series[0].data = []
          option2.series[1].data = this.bar2Data.seriesData
          option2.series[1].itemStyle.borderRadius = 8
          option2.series[2].data = []
        } else if (this.type == 'area') {
          option2.series[0].data = []
          option2.series[1].data = this.bar2Data.seriesData
          option2.series[1].type = 'line'
          option2.series[1].smooth = true
          option2.series[1].symbol = 'circle'
          option2.series[1].symbolSize = 6
          option2.series[1].areaStyle = {
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              {
                offset: 1,
                color: 'rgba(254,171,102,0)',
              },
              {
                offset: 0,
                color: 'rgba(235,92,91,0.7)',
              },
            ]),
          }
          option2.series[2].data = []
        }
        if (this.theme == 'red') {
          if (this.type != "area") {
            option2.series[1].itemStyle.color = params => {
              if (params.data.value < 0) {
                return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0, // 0%处的颜色
                    color: '#d32f2e',
                  },
                  {
                    offset: 1, // 100%处的颜色
                    color: '#FEAB66',
                  },
                ])
              } else {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 0, // 0%处的颜色
                    color: '#d32f2e',
                  },
                  {
                    offset: 1, // 100%处的颜色
                    color: '#FEAB66',
                  },
                ])
              }
            }
          }
        } else if (this.theme == 'purple') {
          option2.series[0].itemStyle.color = '#D9EFFF'
          option2.series[1].itemStyle.color = '#8BCAEA'
          if (option2.series[1].areaStyle) {
            option2.series[1].areaStyle = {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: 'rgba(139, 202, 234, 0)',
                },
                {
                  offset: 0,
                  color: 'rgba(139, 202, 234, 0.70)',
                },
              ]),
            }
          }
          if (this.type != '3d') {
            option2.series[1].backgroundStyle.color = 'rgba(139,202,234,0.2)'
          }
          option2.series[1].label.color = '#2A234C'
          option2.series[1].label.fontSize = 12
          option2.series[1].label.fontWeight = 400
          option2.series[2].itemStyle.color = '#72BDE4'
        } else if (this.theme == 'blue') {
          option2.color = ['#4782EA']
          if (this.type == '3d') {
            option2.series[1].backgroundStyle = {
              color: '#ECF2FD',
              borderRadius: 0,
            }
          } else {
            option2.series[1].backgroundStyle.color = '#E5E5E5'
          }
          option2.series[0].itemStyle.color = '#92D5FF'
          option2.series[1].itemStyle.color = params => {
            if (params.data.value < 0) {
              return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1, // 0%处的颜色
                  color: '#59B9F5',
                },
                {
                  offset: 0, // 100%处的颜色
                  color: '#D7F0FF',
                },
              ])
            } else {
              return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#59B9F5',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#D7F0FF',
                },
              ])
            }
          }
          if (option2.series[1].areaStyle) {
            option2.series[1].areaStyle = {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: 'rgba(91, 186, 245, 0)',
                },
                {
                  offset: 0,
                  color: 'rgba(103, 191, 245, 1)',
                },
              ]),
            }
          }
          option2.series[1].label.color = '#000000'
          option2.series[1].label.fontSize = 12
          option2.series[1].label.fontWeight = 400
          option2.series[2].itemStyle.color = '#C0E6FF'
        } else if (this.theme == 'yellow') {
          option2.color = ['#F8BC27']
          option2.series[0].itemStyle.color = '#FFBE1E'
          option2.series[1].itemStyle.color = params => {
            if (params.data.value < 0) {
              return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                {
                  offset: 1, // 0%处的颜色
                  color: 'rgba(248,188,39,0)',
                },
                {
                  offset: 0, // 100%处的颜色
                  color: 'rgba(248,188,39,0.7)',
                },
              ])
            } else {
              return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: 'rgba(248,188,39,0)',
                },
                {
                  offset: 0,
                  color: 'rgba(248,188,39,0.7)',
                },
              ])
            }
          }
          if (option2.series[1].areaStyle) {
            option2.series[1].areaStyle = {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: 'rgba(248,188,39,0)',
                },
                {
                  offset: 0,
                  color: 'rgba(248,188,39,0.7)',
                },
              ]),
            }
          }
          if (this.type == 'bar') {
            option2.series[1].itemStyle.color = '#F8BC27'
            option2.series[1].backgroundStyle.color = '#EAEAEA'
          }
          option2.series[1].label.color = '#000000'
          option2.series[1].label.fontSize = 12
          option2.series[1].label.fontWeight = 400
          option2.series[2].itemStyle.color = '#DFA20A'
        }

        option2.series[1].label.formatter = function (params) {
          // 使用自定义的 labelValue 来显示标签
          return params.data.label + '%'
        }
        const arr = this.bar2Data.seriesData.filter(item => item.value < 0)
        if (arr.length > 0) {
          option2.xAxis[0].min = -100
          option2.yAxis[0].axisLine.show = true
        }
        myChart2.setOption(option2)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.red {
  .profitability {
    margin-top: 14px;
    width: 1040px;
    height: 503px;
    position: relative;
    background: #ffffff;
    box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
  }
}

.purple {
  .profitability {
    margin-top: 14px;
    width: 1040px;
    height: 503px;
    position: relative;
    background: #ffffff;
    box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
  }
}

.cards {
  margin-top: 14px;
  padding: 0 36px;
  display: flex;
  justify-content: space-around;
}

.top {
  margin-top: 12px;
  margin-left: 50px;
  width: 940px;
  height: 67px;
  border-radius: 8px;
  border: 1px solid var(--borderColor);
  display: flex;
  align-items: center;
  justify-content: center;
}

.zh_income {
  height: 33px;
  font-size: 24px;
  font-weight: 600;
  color: var(--contentTitleColor);
  line-height: 33px;
}

.en_income {
  height: 40px;
  font-size: 28px;
  font-weight: 600;
  color: var(--contentTitleColor);
  line-height: 40px;
}

.money {
  height: 59px;
  font-size: 42px;
  font-weight: 600;
  color: var(--numColor);
  line-height: 59px;
}

.unit {
  font-size: 16px;
}

.card {
  width: 454px;
  height: 252px;
  border-radius: 8px;
  border: 1px solid var(--borderColor);
  text-align: center;
}

.column {
  display: flex;
  justify-content: space-between;
}

.line {
  margin: 22px 8px 0 8px;
  width: 1px;
  height: 132px;
  background-color: #f9eded;
}

.zh .card-title {
  margin-top: 36px;
  height: 30px;
  font-size: 18px;
  font-weight: 600;
  color: var(--timeTitleColor);
  line-height: 25px;
}

.zh .card-text {
  height: 30px;
  font-weight: 600;
  line-height: 25px;
  color: var(--contentTitleColor);
  font-size: 22px;
}

.zh .num {
  height: 50px;
  font-size: 36px;
  font-weight: 600;
  color: var(--numColor);
  line-height: 50px;
}

.unit {
  font-size: 16px;
}

.en .card-title {
  margin-top: 16px;
  height: 30px;
  font-size: 18px;
  font-weight: 600;
  color: var(--timeTitleColor);
  line-height: 25px;
}

.en .card-text {
  height: 30px;
  font-weight: 600;
  line-height: 25px;
  font-size: 22px;
  color: var(--contentTitleColor);
}

.en .num {
  height: 50px;
  font-size: 36px;
  font-weight: 600;
  color: var(--numColor);
  line-height: 50px;
}

.charts {
  width: 450px;
  height: 140px;
}

.blue {
  .profitability {
    padding: 0 80px;
    padding-top: 27px;
    width: 980px;
    height: 489px;
    position: relative;
  }

  .top {
    margin: 0;
    margin-top: 34px;
    width: 980px;
    height: 78px;
    background: #ecf2fd;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
  }

  .zh_income {
    color: #000000;
  }

  .en_income {
    color: #000000;
  }

  .cards {
    padding: 0;
    margin-top: 24px;
    display: flex;
    justify-content: center;
  }

  .card {
    width: 470px;
    height: 273px;
    background: #ecf2fd;
    border-radius: 8px;
    border: none;
    text-align: center;
  }

  .card:nth-child(2) {
    margin-left: 40px;
  }
}

.yellow {
  .profitability {
    width: 980px;
    height: 510px;
    padding: 0 80px;
    background: #f5f6f8;
    border-radius: 28px;
    position: relative;
  }

  .top {
    margin: 0;
    margin-top: 34px;
    width: 980px;
    height: 78px;
    background: #ffffff;
    box-shadow: 6px 2px 9px 0px rgba(165, 165, 165, 0.2);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
  }

  .zh_income {
    color: #000000;
  }

  .en_income {
    color: #000000;
  }

  .cards {
    margin-top: 24px;
    padding: 0;
    display: flex;
    justify-content: center;
  }

  .card {
    width: 470px;
    height: 273px;
    background: #ffffff;
    box-shadow: 6px 2px 9px 0px rgba(165, 165, 165, 0.2);
    border-radius: 8px;
    border: none;
  }

  .card:nth-child(2) {
    margin-left: 40px;
  }
}
</style>
